var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("notifications", {
        attrs: {
          max: 2,
          group: "bottomright",
          classes: "notification-styling",
          position: "bottom right",
        },
      }),
      _vm._v(" "),
      _c("notifications", {
        attrs: {
          max: 2,
          group: "topcenter",
          classes: "notification-styling",
          position: "top center",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }